import { useSettings } from '#~/account/components/hooks.js';
import { usePopupStore } from '#~/store/popup.js';
import { useUser } from '#~/user/hooks.js';
import { Details } from './details.jsx';
import type { Props } from './types.js';
import { Avatar } from '@studio/design-system/avatar';
import * as DropdownMenu from '@studio/design-system/dropdown-menu';
import { Icon } from '@studio/design-system/icon';
import { Ellipses } from '@studio/design-system/label';
import { Sel, STagNew } from '#~/stag/index.js';
import { pick } from 'lodash-es';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { shallow } from 'zustand/shallow';

/** `<Account>` component. */
export const Account = ({ className, ...props }: Props): ReactElement => {
  const user = useUser((µ) => pick(µ, ['email', 'firstName', 'profilePhotoUrl']), shallow);
  const settings = useSettings();
  const { setPopup } = usePopupStore();

  return (
    <DropdownMenu.Root
      onOpenChange={(open) => {
        if (open) {
          setPopup(false);
        }
      }}
    >
      <DropdownMenu.Trigger className='group'>
        <div
          className={twMerge('flex h-32 items-center gap-8 text-sm', className)}
          {...props}
          {...STagNew(Sel.AccountDropdown, 'trigger')}
        >
          <Avatar name={user.firstName} photo={user.profilePhotoUrl} />
          <Ellipses title={user.firstName}>
            <p className='font-demibold'>{user.firstName}</p>
          </Ellipses>
          <Icon className='transition-transform group-x-open:rotate-180' icon='chevron-up' />
        </div>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content align='end'>
        <Details {...user} onSettings={settings} />
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
